import React, { useEffect, useState } from "react"
import { cn } from "lib/utils"
import { ElementButton } from "./elements"
import type { ElementButtonProps } from "./elements/ElementButton"
import { Menubar } from "lib/components"


export default function Titlebar({
  title="No title available",
  item=null,
  editFn,
  buttons,
  comp,
  titleClass="",
  className=""
}:{
  title:string;
  item?:any;
  editFn?:Function;
  buttons?:ElementButtonProps[];
  comp?:any
  titleClass?:string;
  className?:string;
}){

  const [ isEditing, setIsEditing ] = useState(false)
  const [ titleValue, setTitleValue ] = useState(title)
  const [ ExtraComponent, setExtraComponent ] = useState<any>() 

  useEffect(() => {
    if( comp ){
      const CompToAdd = comp
      setExtraComponent(CompToAdd)
    }
  },[comp])

  return (
    <div 
      className={cn(
        "w-full h-8 bg-slate-700 p-[2px] flex justify-between items-center", 
        className
      )}
    >
      <div 
        className={cn(
          "h-8 flex justify-start items-center p-[2px]",
          !buttons || buttons.length === 0 || !comp ? "w-full" : "w-7/12",
        )}
      >
        <input 
          type="text" 
          className={cn(
            "w-full h-full bg-transparent text-neutral-200 text-sm px-1 border-none outline-none", 
            isEditing ? "border border-solid border-slate-800" : "border-none",
            titleClass
          )}
          readOnly={!isEditing}
          value={titleValue}
          onChange={(e:any) => setTitleValue(e.target.value)}
          onFocus={ () => (editFn !== undefined) ? setIsEditing(true) : null }
          onBlur={() => {
            setIsEditing(false)
            if( editFn ) editFn(titleValue)
          }}
        />
      </div>
      { ((buttons !== undefined && buttons.length > 0) || (comp !== undefined)) && (
        <div className="w-5/12 flex justify-end items-center gap-1">
          { comp }
          { buttons?.map( (btn:ElementButtonProps, i:number) => (
            <ElementButton 
              key={i}
              type={btn.type}
              item={item}
              label={btn.label}
              onClick={btn.onClick}
              className={cn(btn.className)}
              disabled={btn.disabled}
              visible={btn.visible}
            />
          )) }
        </div>
      )}
    </div>
  )
}